import type { SelectOption } from "@pack-it-up/ui-web";

// Hour-of-day options for the reminder-time picker (Doc 04 §6 / Doc 09 §4).
export const hourOptions: SelectOption[] = Array.from({ length: 24 }, (_, h) => {
  const period = h < 12 ? "AM" : "PM";
  const twelve = h % 12 === 0 ? 12 : h % 12;
  return { value: String(h), label: `${twelve}:00 ${period}` };
});

const CURATED_ZONES = [
  "America/Los_Angeles",
  "America/Denver",
  "America/Chicago",
  "America/New_York",
  "Europe/London",
  "Europe/Paris",
  "Europe/Berlin",
  "Asia/Tokyo",
  "Asia/Shanghai",
  "Asia/Kolkata",
  "Australia/Sydney",
  "Pacific/Auckland",
  "UTC",
];

// IANA timezone options. Uses the full supported list when the runtime provides it
// (modern browsers), else a curated subset. `current` is always included so the
// stored value is selectable even if it isn't in the list.
export const timezoneOptions = (current?: string): SelectOption[] => {
  const supported = (Intl as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf;
  const zones = supported ? supported("timeZone") : CURATED_ZONES;
  const set = new Set(zones);
  if (current !== undefined) set.add(current);
  return [...set].sort().map((z) => ({ value: z, label: z }));
};
